import React, { useContext } from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { MatureDeviationContext } from '../../Context/MatureDeviationContext';
import EmptyBackground from './EmptyBackground';
import JournalStageBackground from './Journal';
import DefaultStageBackground from './Default';
import LiteratureStageBackground from './Literature';
import StatusStageBackground from './Status';
import { StageBackgroundProps } from './types';
import CommissionStageBackground from './Commission';

const StageBackground: React.FC<StageBackgroundProps> = props => {
  const { showBlocked } = useContext(MatureDeviationContext);
  if (props.deviation.isBlocked && showBlocked) {
    return <EmptyBackground />;
  }

  const deviationType = getDeviationType(props.deviation);
  switch (deviationType) {
    case DeviationTypes.COMMISSION:
      return <CommissionStageBackground {...props} />;
    case DeviationTypes.POLL:
      return <EmptyBackground />;
    case DeviationTypes.STATUS:
      return <StatusStageBackground {...props} />;
    case DeviationTypes.LITERATURE:
      return <LiteratureStageBackground {...props} />;
    case DeviationTypes.TIER:
    case DeviationTypes.JOURNAL:
      return <JournalStageBackground {...props} />;
    default:
      return <DefaultStageBackground {...props} />;
  }
};

StageBackground.displayName = 'StageBackground';

export default StageBackground;
